import RetailerPricingRuleStore from './RetailerPricingRuleStore'

export default RetailerPricingRuleStore
